<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body" >
      <div>
        <div class="row no-gutters">
          <div class="col-md-12 text-center modal-header align-items-center">
            <div class="header-container row no-gutters justify-content-between w-100 px-4">
              <h3 class="text-center">Slack Accounts Payable</h3>
              <button class="close close-btn" :disabled="isLoading" @click="closeAndCancel">
                <img src="../assets/images/icon-close.svg" />
              </button>
            </div>
          </div>
        </div>
        <div class="row no-gutters close-case-container">
          <div class="overlay-loader-container" v-if="isLoading">
            <img class="overlay-loader loading-spinner" :src="CONSTANTS.SPINNER_URL" alt="Loading Spinner">
          </div>

          <div class="col-12" v-else>
            <div class="alert-container mb-2" v-if="errorMessage">
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{errorMessage}}</strong></div>
              </div>
            </div>

            <div class="close-comments-container">
              <div class="required-field">Post your question to <a class="solution-link" :href="CONSTANTS.ACCOUNTS_PAYABLE_SLACK" target="_blank"><strong>Accounts Payable</strong></a> channel</div>
              <textarea
                  class="w-100 close-comments mt-2 p-1"
                  v-model="questionPosted"
                  v-validate="'required'"
                  data-vv-validate-on="input"
                  name="questionPosted"
              ></textarea>
              <div class="text-danger input-error-text" v-if="errors.has('questionPosted')">
                This field is required.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row buttons-group no-gutters justify-content-end pb-2 px-md-0 px-3 ml-md-0 ml-3" v-if="!isLoading">
        <button class="btn-container flat-btn gray-btn close-btn btn mx-2 mx-3" @click="closeAndCancel">Cancel</button>
        <button class="btn-container btn flat-btn submit-btn mr-md-4 mx-md-0 mx-3 mt-md-0 mt-3" @click="postToSlack">Send</button>
      </div>
    </div>

  </div>
</template>

<script>
import api from "@/api";
import CONSTANTS from "@/store/constants";
export default {
  name: "SendUserToSlackModal",
  props: ["postToSlackData"],
  data(){
    return{
      isLoading: false,
      errorMessage: '',
      questionPosted: '',
      slackMessageObj : {}
    }
  },
  methods: {
    async postToSlack(){
      const isValidationSuccess = await this.$validator.validateAll()
      if(isValidationSuccess) {
        this.isLoading = true
        let response = {}
        //This method is to configure properties based on what API requires for POModal/InvoiceModal
        this.configureSlackMessageObj()
        try {
            response = await api.sendInformationToAccountsPayable(this.slackMessageObj,this.questionPosted)
        } catch (e) {
          this.isLoading = false
          this.errorMessage = CONSTANTS.ERROR_MESSAGE
        } finally {
          this.isLoading = false
          if(response && response.data && response.data.data && response.data.data.sendSlackMessage && response.data.data.sendSlackMessage.success) {
            this.$parent.$emit('onClosed', true)
          } else {
            this.errorMessage = CONSTANTS.ERROR_MESSAGE
          }
        }
      }
    },
    configureSlackMessageObj(){
       if (this.postToSlackData.invoiceAmount && this.postToSlackData.docId && this.postToSlackData.invoiceNumber){
         let formattedInvoiceAmount = this.postToSlackData.invoiceAmount.split(" ")
         this.slackMessageObj.companyCode = this.postToSlackData.companyCode
         this.slackMessageObj.poNumber = this.postToSlackData.poNumber
         this.slackMessageObj.netValue = formattedInvoiceAmount[1]
         this.slackMessageObj.docId = this.postToSlackData.docId
         this.slackMessageObj.invoiceNumber = this.postToSlackData.invoiceNumber
         this.slackMessageObj.currency = this.postToSlackData.currency
       }else{
         this.slackMessageObj.companyCode = this.postToSlackData.companyCode
         this.slackMessageObj.poNumber = this.postToSlackData.poNumber
         this.slackMessageObj.netValue = this.postToSlackData.netValue
         this.slackMessageObj.currency = this.postToSlackData.poCurrency
       }
    },
    closeAndCancel(){
      this.$parent.$emit('closeAndCancel');
    }
  }

}
</script>

<style scoped>
.modal-container {
  background-color: #fff;
  overflow-y: auto !important;
  height: 100%;
  overflow-x: hidden;
}

.close-case-container {
  padding: 20px;
}

.close-comments {
  resize: none;
  min-height: 90px;
}

.overlay-loader {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.overlay-loader-container {
  height: 220px;
  width: 100%;
}

.modal-container {
  padding-bottom: 20px;
}


@media (max-width: 800px) {
  .modal-container {
    height: 55vh;
  }
}

.form-content-body {
  height: 100%;
}

.flat-btn {
  margin-top: 0px;
}


.btn-container {
  margin-bottom: 0;
}

.close-comments-container {
  min-height: 175px;
}
</style>